import {SurveyData} from 'screens/InsomniaSurvey/utils/surveyData';

export const setValueInSurveyData = (key: string, value: unknown) => {
  const surveyData = SurveyData.read() ?? {};
  if (value === undefined) {
    delete surveyData[key];
  } else {
    surveyData[key] = value;
  }
  if (typeof window !== 'undefined') {
    window.localStorage.setItem('rise-survey-data', JSON.stringify(surveyData));
  }
};
